import { h, Component } from 'preact';
import dlv from 'dlv';

import { DailymotionJs } from './dailymotion-js';
import { JwPlayer } from './jwplayer';
import { Youtube } from './youtube';

/** Loads correct Video Player
 */
export class VideoPlayer extends Component {

	render({ player, asset, article, ...props }) {
		if (!player) return;
        
		player = player.toLowerCase();

		if (player === 'dailymotion' && article) return <DailymotionJs noWrapper id={article} />;
		if (player === 'sf' && asset) return <JwPlayer video={asset} {...props} />;
		if (player === 'youtube' && dlv(asset, 'videos.0.metadata.content')) return <Youtube id={asset.videos[0].metadata.content} {...props} />;
	}
}
